"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    root: {
      zIndex: 1350,
      color: '#FFFFFF',
      backgroundColor: 'rgba(0,0,0,0.87)',
      height: '100vh',
      width: '100%',
      fontWeight: typography.fontWeightLight,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0
    },
    title: {
      marginBottom: '40px',
      color: '#FFFFFF'
    },
    progressWrapper: {
      position: 'relative',
      display: 'inline-flex'
    },
    timeWrapper: {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    time: {
      color: '#FFFFFF'
    },
    detail: {
      fontWeight: typography.fontWeightLight,
      '&:nth-of-type(1)': {
        marginTop: '30px',
        marginBottom: '55px'
      },
      '&:nth-of-type(2)': {
        marginBottom: '50px'
      }
    },
    logoutBtn: {
      border: '1px solid #FFFFFF',
      marginRight: '16px'
    },
    loader: {
      height: '140px !important',
      width: '140px !important',
      transform: 'rotate(-90deg) !important'
    },
    strong: {
      fontWeight: typography.fontWeightBold
    },
    hide: {
      display: 'none'
    }
  };
}, {
  name: 'TimeoutModal'
});
exports.useStyles = useStyles;